type Props = {
    color?: string;
    width?: string;
    height?: string;
};

export const CapabilitiesIcon = (props: Props) => {
    return (
        <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_769_1005)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.5 3.33333C4.13181 3.33333 3.83333 3.63181 3.83333 4V12C3.83333 12.3682 4.13181 12.6667 4.5 12.6667H12.5C12.8682 12.6667 13.1667 12.3682 13.1667 12V4C13.1667 3.63181 12.8682 3.33333 12.5 3.33333H4.5ZM2.5 4C2.5 2.89543 3.39543 2 4.5 2H12.5C13.6046 2 14.5 2.89543 14.5 4V12C14.5 13.1046 13.6046 14 12.5 14H4.5C3.39543 14 2.5 13.1046 2.5 12V4Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.83398 5.99992C5.83398 5.63173 6.13246 5.33325 6.50065 5.33325H10.5007C10.8688 5.33325 11.1673 5.63173 11.1673 5.99992V9.99992C11.1673 10.3681 10.8688 10.6666 10.5007 10.6666H6.50065C6.13246 10.6666 5.83398 10.3681 5.83398 9.99992V5.99992ZM7.16732 6.66659V9.33325H9.83398V6.66659H7.16732Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.50065 0C6.86884 0 7.16732 0.298477 7.16732 0.666667V2.66667C7.16732 3.03486 6.86884 3.33333 6.50065 3.33333C6.13246 3.33333 5.83398 3.03486 5.83398 2.66667V0.666667C5.83398 0.298477 6.13246 0 6.50065 0Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5007 0C10.8688 0 11.1673 0.298477 11.1673 0.666667V2.66667C11.1673 3.03486 10.8688 3.33333 10.5007 3.33333C10.1325 3.33333 9.83398 3.03486 9.83398 2.66667V0.666667C9.83398 0.298477 10.1325 0 10.5007 0Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.50065 12.6667C6.86884 12.6667 7.16732 12.9652 7.16732 13.3334V15.3334C7.16732 15.7016 6.86884 16.0001 6.50065 16.0001C6.13246 16.0001 5.83398 15.7016 5.83398 15.3334V13.3334C5.83398 12.9652 6.13246 12.6667 6.50065 12.6667Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.5007 12.6667C10.8688 12.6667 11.1673 12.9652 11.1673 13.3334V15.3334C11.1673 15.7016 10.8688 16.0001 10.5007 16.0001C10.1325 16.0001 9.83398 15.7016 9.83398 15.3334V13.3334C9.83398 12.9652 10.1325 12.6667 10.5007 12.6667Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.166 5.99992C13.166 5.63173 13.4645 5.33325 13.8327 5.33325H15.8327C16.2009 5.33325 16.4993 5.63173 16.4993 5.99992C16.4993 6.36811 16.2009 6.66659 15.8327 6.66659H13.8327C13.4645 6.66659 13.166 6.36811 13.166 5.99992Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.166 9.33341C13.166 8.96522 13.4645 8.66675 13.8327 8.66675H15.8327C16.2009 8.66675 16.4993 8.96522 16.4993 9.33341C16.4993 9.7016 16.2009 10.0001 15.8327 10.0001H13.8327C13.4645 10.0001 13.166 9.7016 13.166 9.33341Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 5.99992C0.5 5.63173 0.798477 5.33325 1.16667 5.33325H3.16667C3.53486 5.33325 3.83333 5.63173 3.83333 5.99992C3.83333 6.36811 3.53486 6.66659 3.16667 6.66659H1.16667C0.798477 6.66659 0.5 6.36811 0.5 5.99992Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.5 9.33341C0.5 8.96522 0.798477 8.66675 1.16667 8.66675H3.16667C3.53486 8.66675 3.83333 8.96522 3.83333 9.33341C3.83333 9.7016 3.53486 10.0001 3.16667 10.0001H1.16667C0.798477 10.0001 0.5 9.7016 0.5 9.33341Z"
                    fill={props.color ? props.color : "black"}
                />
            </g>
            <defs>
                <clipPath id="clip0_769_1005">
                    <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const LimitationsIcon = (props: Props) => {
    return (
        <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.7">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.26794 1.36201C5.39297 1.23699 5.56254 1.16675 5.73935 1.16675H11.2593C11.4362 1.16675 11.6057 1.23699 11.7308 1.36201L15.6374 5.26868C15.7624 5.3937 15.8327 5.56327 15.8327 5.74008V11.2601C15.8327 11.4369 15.7624 11.6065 15.6374 11.7315L11.7308 15.6382C11.6057 15.7632 11.4362 15.8334 11.2593 15.8334H5.73935C5.56254 15.8334 5.39297 15.7632 5.26794 15.6382L1.36128 11.7315C1.23625 11.6065 1.16602 11.4369 1.16602 11.2601V5.74008C1.16602 5.56327 1.23625 5.3937 1.36128 5.26868L5.26794 1.36201ZM6.01549 2.50008L2.49935 6.01622V10.9839L6.01549 14.5001H10.9832L14.4993 10.9839V6.01622L10.9832 2.50008H6.01549Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.50065 5.16675C8.86884 5.16675 9.16732 5.46522 9.16732 5.83341V8.50008C9.16732 8.86827 8.86884 9.16675 8.50065 9.16675C8.13246 9.16675 7.83398 8.86827 7.83398 8.50008V5.83341C7.83398 5.46522 8.13246 5.16675 8.50065 5.16675Z"
                    fill={props.color ? props.color : "black"}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.83398 11.1667C7.83398 10.7985 8.13246 10.5 8.50065 10.5H8.50732C8.87551 10.5 9.17398 10.7985 9.17398 11.1667C9.17398 11.5349 8.87551 11.8333 8.50732 11.8333H8.50065C8.13246 11.8333 7.83398 11.5349 7.83398 11.1667Z"
                    fill={props.color ? props.color : "black"}
                />
            </g>
        </svg>
    );
};

export const VolumeIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.62147 2.73255C7.85245 2.84357 7.99935 3.07715 7.99935 3.33342V12.6668C7.99935 12.923 7.85245 13.1566 7.62147 13.2676C7.3905 13.3786 7.11633 13.3474 6.91622 13.1873L3.7655 10.6668H1.33268C0.964492 10.6668 0.666016 10.3683 0.666016 10.0001V6.00009C0.666016 5.6319 0.964492 5.33342 1.33268 5.33342H3.7655L6.91622 2.81284C7.11633 2.65275 7.3905 2.62154 7.62147 2.73255ZM6.66602 4.7205L4.41581 6.52067C4.2976 6.61523 4.15073 6.66675 3.99935 6.66675H1.99935V9.33342H3.99935C4.15073 9.33342 4.2976 9.38494 4.41581 9.47951L6.66602 11.2797V4.7205Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.242 2.81531C12.5024 2.555 12.9245 2.55506 13.1848 2.81545C14.5596 4.19065 15.3319 6.05558 15.3319 8.00012C15.3319 9.94465 14.5596 11.8096 13.1848 13.1848C12.9245 13.4452 12.5024 13.4452 12.242 13.1849C11.9816 12.9246 11.9816 12.5025 12.2419 12.2421C13.3667 11.117 13.9986 9.5911 13.9986 8.00012C13.9986 6.40913 13.3667 4.88328 12.2419 3.75812C11.9816 3.49773 11.9816 3.07562 12.242 2.81531ZM9.88869 5.16864C10.1491 4.90833 10.5712 4.9084 10.8315 5.16878C11.5814 5.91889 12.0026 6.93613 12.0026 7.99678C12.0026 9.05744 11.5814 10.0747 10.8315 10.8248C10.5712 11.0852 10.1491 11.0852 9.88869 10.8249C9.6283 10.5646 9.62824 10.1425 9.88855 9.88212C10.3885 9.38204 10.6693 8.70389 10.6693 7.99678C10.6693 7.28968 10.3885 6.61152 9.88855 6.11145C9.62824 5.85106 9.6283 5.42895 9.88869 5.16864Z"
                fill="white"
                fill-opacity="0.8"
            />
        </svg>
    );
};

export const SmileyIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_769_888)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99935 2.00008C4.68564 2.00008 1.99935 4.68637 1.99935 8.00008C1.99935 11.3138 4.68564 14.0001 7.99935 14.0001C11.3131 14.0001 13.9993 11.3138 13.9993 8.00008C13.9993 4.68637 11.3131 2.00008 7.99935 2.00008ZM0.666016 8.00008C0.666016 3.94999 3.94926 0.666748 7.99935 0.666748C12.0494 0.666748 15.3327 3.94999 15.3327 8.00008C15.3327 12.0502 12.0494 15.3334 7.99935 15.3334C3.94926 15.3334 0.666016 12.0502 0.666016 8.00008Z"
                    fill="white"
                    fill-opacity="0.8"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.86396 8.93068C5.64251 8.63853 5.22635 8.5799 4.93272 8.80012C4.63817 9.02103 4.57847 9.4389 4.79939 9.73345L5.33272 9.33345C4.79939 9.73345 4.79955 9.73367 4.79971 9.73389L4.80006 9.73435L4.80083 9.73537L4.80266 9.73778L4.80746 9.74406L4.82166 9.76223C4.83316 9.77675 4.84873 9.79601 4.8683 9.81933C4.90739 9.86591 4.96272 9.92901 5.03369 10.0031C5.17507 10.1506 5.38168 10.3449 5.64894 10.5393C6.1809 10.9262 6.98237 11.3335 7.99939 11.3335C9.01641 11.3335 9.81788 10.9262 10.3498 10.5393C10.6171 10.3449 10.8237 10.1506 10.9651 10.0031C11.0361 9.92901 11.0914 9.86591 11.1305 9.81933C11.1501 9.79601 11.1656 9.77675 11.1771 9.76223L11.1913 9.74406L11.1961 9.73778L11.1979 9.73537L11.1987 9.73435L11.1991 9.73389C11.1992 9.73367 11.1994 9.73345 10.6661 9.33345L11.1994 9.73345C11.4203 9.4389 11.3606 9.02103 11.0661 8.80012C10.7724 8.5799 10.3563 8.63853 10.1348 8.93068L10.1317 8.93463C10.1278 8.93964 10.1202 8.94902 10.1092 8.96216C10.0871 8.9885 10.0513 9.02957 10.0024 9.08052C9.90424 9.18299 9.75668 9.322 9.56561 9.46096C9.1809 9.74075 8.64903 10.0001 7.99939 10.0001C7.34974 10.0001 6.81788 9.74075 6.43317 9.46096C6.2421 9.322 6.09454 9.18299 5.99634 9.08052C5.94751 9.02957 5.9117 8.9885 5.88959 8.96216C5.87857 8.94902 5.87102 8.93964 5.86706 8.93463L5.86396 8.93068Z"
                    fill="white"
                    fill-opacity="0.8"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.33398 5.99992C5.33398 5.63173 5.63246 5.33325 6.00065 5.33325H6.00732C6.37551 5.33325 6.67398 5.63173 6.67398 5.99992C6.67398 6.36811 6.37551 6.66659 6.00732 6.66659H6.00065C5.63246 6.66659 5.33398 6.36811 5.33398 5.99992Z"
                    fill="white"
                    fill-opacity="0.8"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.33398 5.99992C9.33398 5.63173 9.63246 5.33325 10.0007 5.33325H10.0073C10.3755 5.33325 10.674 5.63173 10.674 5.99992C10.674 6.36811 10.3755 6.66659 10.0073 6.66659H10.0007C9.63246 6.66659 9.33398 6.36811 9.33398 5.99992Z"
                    fill="white"
                    fill-opacity="0.8"
                />
            </g>
            <defs>
                <clipPath id="clip0_769_888">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const ClockIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_769_893)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.99935 2.00008C4.68564 2.00008 1.99935 4.68637 1.99935 8.00008C1.99935 11.3138 4.68564 14.0001 7.99935 14.0001C11.3131 14.0001 13.9993 11.3138 13.9993 8.00008C13.9993 4.68637 11.3131 2.00008 7.99935 2.00008ZM0.666016 8.00008C0.666016 3.94999 3.94926 0.666748 7.99935 0.666748C12.0494 0.666748 15.3327 3.94999 15.3327 8.00008C15.3327 12.0502 12.0494 15.3334 7.99935 15.3334C3.94926 15.3334 0.666016 12.0502 0.666016 8.00008Z"
                    fill="white"
                    fill-opacity="0.8"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.00065 3.33325C8.36884 3.33325 8.66732 3.63173 8.66732 3.99992V7.5879L10.9655 8.73697C11.2948 8.90163 11.4283 9.30208 11.2636 9.63139C11.0989 9.96071 10.6985 10.0942 10.3692 9.92954L7.70251 8.5962C7.47665 8.48328 7.33398 8.25243 7.33398 7.99992V3.99992C7.33398 3.63173 7.63246 3.33325 8.00065 3.33325Z"
                    fill="white"
                    fill-opacity="0.8"
                />
            </g>
            <defs>
                <clipPath id="clip0_769_893">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export const HumanIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.10087 9.6C8.32441 9.6 8.51193 9.5232 8.66341 9.3696C8.8149 9.216 8.89038 9.02613 8.88985 8.8V4.8C8.88985 4.57333 8.81411 4.38347 8.66262 4.2304C8.51114 4.07733 8.32389 4.00053 8.10087 4C7.87732 4 7.69007 4.0768 7.53911 4.2304C7.38815 4.384 7.31241 4.57387 7.31188 4.8V8.8C7.31188 9.02667 7.38762 9.2168 7.53911 9.3704C7.69059 9.524 7.87785 9.60053 8.10087 9.6ZM10.4678 8.4C10.6914 8.4 10.8789 8.3232 11.0304 8.1696C11.1819 8.016 11.2573 7.82613 11.2568 7.6V5.6C11.2568 5.37333 11.1811 5.18347 11.0296 5.0304C10.8781 4.87733 10.6908 4.80053 10.4678 4.8C10.2443 4.8 10.057 4.8768 9.90606 5.0304C9.75511 5.184 9.67936 5.37387 9.67884 5.6V7.6C9.67884 7.82667 9.75458 8.0168 9.90606 8.1704C10.0575 8.324 10.2448 8.40053 10.4678 8.4ZM5.73391 8C5.95746 8 6.14497 7.9232 6.29646 7.7696C6.44794 7.616 6.52342 7.42613 6.5229 7.2V5.6C6.5229 5.37333 6.44715 5.18347 6.29567 5.0304C6.14418 4.87733 5.95693 4.80053 5.73391 4.8C5.51037 4.8 5.32311 4.8768 5.17215 5.0304C5.02119 5.184 4.94545 5.37387 4.94493 5.6V7.2C4.94493 7.42667 5.02067 7.6168 5.17215 7.7704C5.32364 7.924 5.51089 8.00053 5.73391 8ZM3.36696 16V12.56C2.61742 11.8667 2.03567 11.0568 1.62172 10.1304C1.20777 9.204 1.00053 8.2272 1 7.2C1 5.2 1.69036 3.5 3.07109 2.1C4.45181 0.7 6.1284 0 8.10087 0C9.74459 0 11.2011 0.490133 12.4703 1.4704C13.7395 2.45067 14.5645 3.7272 14.9453 5.3L15.971 9.4C16.0367 9.65333 15.9907 9.88347 15.8329 10.0904C15.6751 10.2973 15.4647 10.4005 15.2017 10.4H13.6238V12.8C13.6238 13.24 13.4694 13.6168 13.1606 13.9304C12.8519 14.244 12.4803 14.4005 12.0458 14.4H10.4678V16H8.88985V12.8H12.0458V8.8H14.1761L13.4265 5.7C13.1241 4.48667 12.4797 3.5 11.4935 2.74C10.5073 1.98 9.37639 1.6 8.10087 1.6C6.57549 1.6 5.27367 2.14 4.19539 3.22C3.11711 4.3 2.57797 5.61333 2.57797 7.16C2.57797 7.96 2.73919 8.72 3.06162 9.44C3.38405 10.16 3.84087 10.8 4.43209 11.36L4.94493 11.84V16H3.36696Z"
                fill="white"
                fill-opacity="0.8"
            />
        </svg>
    );
};

export const InfoIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.58579 1.25253C2.96086 0.877462 3.46957 0.666748 4 0.666748H9.33333C9.51014 0.666748 9.67971 0.736986 9.80474 0.86201L13.8047 4.86201C13.9298 4.98703 14 5.1566 14 5.33342V13.3334C14 13.8638 13.7893 14.3726 13.4142 14.7476C13.0391 15.1227 12.5304 15.3334 12 15.3334H4C3.46957 15.3334 2.96086 15.1227 2.58579 14.7476C2.21071 14.3726 2 13.8638 2 13.3334V2.66675C2 2.13632 2.21071 1.62761 2.58579 1.25253ZM4 2.00008C3.82319 2.00008 3.65362 2.07032 3.5286 2.19534C3.40357 2.32037 3.33333 2.48994 3.33333 2.66675V13.3334C3.33333 13.5102 3.40357 13.6798 3.5286 13.8048C3.65362 13.9298 3.82319 14.0001 4 14.0001H12C12.1768 14.0001 12.3464 13.9298 12.4714 13.8048C12.5964 13.6798 12.6667 13.5102 12.6667 13.3334V5.60956L9.05719 2.00008H4Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.33268 0.666748C9.70087 0.666748 9.99935 0.965225 9.99935 1.33341V4.66675H13.3327C13.7009 4.66675 13.9993 4.96523 13.9993 5.33342C13.9993 5.7016 13.7009 6.00008 13.3327 6.00008H9.33268C8.96449 6.00008 8.66602 5.7016 8.66602 5.33342V1.33341C8.66602 0.965225 8.96449 0.666748 9.33268 0.666748Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00716 10C7.63897 10 7.34049 9.70152 7.34049 9.33333L7.3405 6.66667C7.3405 6.29848 7.63897 6 8.00716 6C8.37535 6 8.67383 6.29848 8.67383 6.66667L8.67383 9.33333C8.67383 9.70152 8.37535 10 8.00716 10Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.67383 12.0001C8.67383 12.3683 8.37535 12.6667 8.00716 12.6667L8.00049 12.6667C7.6323 12.6667 7.33383 12.3683 7.33383 12.0001C7.33383 11.6319 7.6323 11.3334 8.00049 11.3334L8.00716 11.3334C8.37535 11.3334 8.67383 11.6319 8.67383 12.0001Z"
                fill="white"
                fill-opacity="0.8"
            />
        </svg>
    );
};

export const TriangleIcon = (props: Props) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.018 1.52212C7.31753 1.35348 7.65547 1.26489 7.9992 1.26489C8.34294 1.26489 8.68087 1.35348 8.9804 1.52212C9.27992 1.69076 9.53093 1.93374 9.7092 2.22764L9.71112 2.2308L15.3578 11.6575L15.3632 11.6667C15.5378 11.9691 15.6302 12.312 15.6312 12.6612C15.6322 13.0104 15.5417 13.3538 15.3688 13.6572C15.1958 13.9606 14.9465 14.2134 14.6455 14.3905C14.3445 14.5676 14.0024 14.6628 13.6532 14.6667L13.6459 14.6668L2.34521 14.6667C1.996 14.6629 1.65389 14.5676 1.35291 14.3905C1.05193 14.2134 0.802568 13.9606 0.629633 13.6572C0.456697 13.3538 0.366218 13.0104 0.367195 12.6612C0.368173 12.312 0.460575 11.9691 0.635206 11.6667L0.640622 11.6575L6.28919 2.22763C6.46746 1.93374 6.71848 1.69076 7.018 1.52212ZM7.9992 2.59823C7.88462 2.59823 7.77198 2.62776 7.67214 2.68397C7.57274 2.73993 7.48938 2.82044 7.43001 2.91781L1.78766 12.3373C1.73087 12.4371 1.70085 12.55 1.70052 12.6649C1.7002 12.7813 1.73036 12.8958 1.788 12.9969C1.84565 13.0981 1.92877 13.1823 2.0291 13.2414C2.12855 13.2999 2.24146 13.3316 2.3568 13.3334H13.6416C13.7569 13.3316 13.8699 13.2999 13.9693 13.2414C14.0696 13.1823 14.1528 13.0981 14.2104 12.9969C14.268 12.8958 14.2982 12.7813 14.2979 12.6649C14.2976 12.55 14.2675 12.4372 14.2108 12.3373L8.5692 2.91914C8.56893 2.9187 8.56866 2.91826 8.56839 2.91781C8.50902 2.82044 8.42566 2.73993 8.32627 2.68397C8.22642 2.62776 8.11378 2.59823 7.9992 2.59823Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.00065 5.33325C8.36884 5.33325 8.66732 5.63173 8.66732 5.99992V8.66659C8.66732 9.03478 8.36884 9.33325 8.00065 9.33325C7.63246 9.33325 7.33398 9.03478 7.33398 8.66659V5.99992C7.33398 5.63173 7.63246 5.33325 8.00065 5.33325Z"
                fill="white"
                fill-opacity="0.8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.33398 11.3334C7.33398 10.9652 7.63246 10.6667 8.00065 10.6667H8.00732C8.37551 10.6667 8.67398 10.9652 8.67398 11.3334C8.67398 11.7016 8.37551 12.0001 8.00732 12.0001H8.00065C7.63246 12.0001 7.33398 11.7016 7.33398 11.3334Z"
                fill="white"
                fill-opacity="0.8"
            />
        </svg>
    );
};

export const NoChat = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="109"
            height="105"
            viewBox="0 0 109 105"
            fill="none"
        >
            <g opacity="0.4" clip-path="url(#clip0_1026_593)">
                <path
                    d="M69.062 23.6141H39.9607C39.2975 23.6149 38.6618 23.8776 38.1928 24.3447C37.7239 24.8118 37.4601 25.445 37.4593 26.1055V90.5249L37.1258 90.6262L29.9868 92.8037C29.6484 92.9064 29.283 92.8713 28.9706 92.7059C28.6583 92.5406 28.4246 92.2585 28.3209 91.9217L7.08556 22.8351C6.98221 22.4981 7.01744 22.1341 7.18348 21.8229C7.34953 21.5118 7.6328 21.279 7.97106 21.1758L18.9723 17.8208L50.8652 8.09764L61.8663 4.74254C62.0337 4.69122 62.2097 4.67329 62.3841 4.68977C62.5584 4.70625 62.7278 4.75682 62.8826 4.83858C63.0373 4.92035 63.1744 5.0317 63.2858 5.16628C63.3973 5.30085 63.4811 5.456 63.5323 5.62284L68.9603 23.2819L69.062 23.6141Z"
                    fill="#F2F2F2"
                />
                <path
                    d="M75.4141 23.2823L68.8721 1.9991C68.7632 1.64448 68.5853 1.3147 68.3484 1.0286C68.1116 0.742498 67.8204 0.505688 67.4917 0.331698C67.1629 0.157708 66.8029 0.049947 66.4323 0.0145776C66.0617 -0.0207918 65.6877 0.0169231 65.3317 0.125563L49.8647 4.84096L17.9735 14.5657L2.50652 19.2828C1.788 19.5025 1.18638 19.9973 0.833703 20.6584C0.481029 21.3195 0.406116 22.0929 0.625411 22.809L22.9846 95.5463C23.1628 96.1243 23.5222 96.6303 24.0103 96.9899C24.4983 97.3495 25.0892 97.5438 25.6962 97.5444C25.9772 97.5446 26.2565 97.5026 26.525 97.4199L37.1276 94.1877L37.4611 94.0847V93.7376L37.1276 93.8389L26.4266 97.1026C25.7924 97.2952 25.1074 97.2293 24.5218 96.9195C23.9363 96.6097 23.498 96.0812 23.3032 95.45L0.945659 22.711C0.84912 22.3982 0.815473 22.0695 0.846645 21.7438C0.877817 21.4181 0.973192 21.1016 1.12732 20.8127C1.28144 20.5237 1.49128 20.2679 1.74482 20.0598C1.99837 19.8517 2.29063 19.6955 2.60487 19.6L18.0719 14.883L49.9632 5.15986L65.4302 0.442805C65.6685 0.370355 65.9163 0.333414 66.1655 0.333183C66.7004 0.334379 67.2207 0.506112 67.6505 0.823229C68.0802 1.14035 68.3967 1.58618 68.5536 2.09544L75.0656 23.2823L75.169 23.6145H75.5158L75.4141 23.2823Z"
                    fill="#3F3D56"
                />
                <path
                    d="M20.9583 21.2302C20.6369 21.23 20.3241 21.1272 20.0656 20.9369C19.8072 20.7466 19.6168 20.4788 19.5223 20.1728L17.3744 13.1849C17.3167 12.9972 17.2966 12.8 17.3154 12.6046C17.3342 12.4092 17.3915 12.2194 17.484 12.046C17.5765 11.8726 17.7023 11.7191 17.8544 11.5942C18.0064 11.4693 18.1817 11.3754 18.3701 11.318L47.7098 2.37155C48.0904 2.25587 48.5015 2.29532 48.853 2.48125C49.2044 2.66717 49.4674 2.98438 49.5843 3.36324L51.7322 10.3512C51.8483 10.7303 51.8086 11.1397 51.622 11.4897C51.4353 11.8398 51.1169 12.1017 50.7365 12.2182L21.3968 21.1646C21.2547 21.208 21.107 21.2302 20.9583 21.2302Z"
                    fill="#236B48"
                />
                <path
                    d="M32.2102 7.46674C34.0522 7.46674 35.5454 5.97949 35.5454 4.14487C35.5454 2.31025 34.0522 0.822998 32.2102 0.822998C30.3682 0.822998 28.875 2.31025 28.875 4.14487C28.875 5.97949 30.3682 7.46674 32.2102 7.46674Z"
                    fill="#236B48"
                />
                <path
                    d="M32.2096 6.24828C33.376 6.24828 34.3216 5.30651 34.3216 4.14477C34.3216 2.98303 33.376 2.04126 32.2096 2.04126C31.0432 2.04126 30.0977 2.98303 30.0977 4.14477C30.0977 5.30651 31.0432 6.24828 32.2096 6.24828Z"
                    fill="white"
                />
                <path
                    d="M100.995 96.6952H44.6304C44.2546 96.6948 43.8943 96.5459 43.6285 96.2813C43.3628 96.0166 43.2133 95.6577 43.2129 95.2834V28.0156C43.2133 27.6413 43.3628 27.2824 43.6285 27.0177C43.8943 26.7531 44.2545 26.6042 44.6304 26.6038H100.995C101.371 26.6042 101.731 26.7531 101.997 27.0177C102.263 27.2824 102.412 27.6413 102.413 28.0156V95.2834C102.412 95.6577 102.263 96.0166 101.997 96.2812C101.731 96.5459 101.371 96.6948 100.995 96.6952Z"
                    fill="#E6E6E6"
                />
                <path
                    d="M75.0649 23.282H39.9619C39.2103 23.283 38.4899 23.5809 37.9585 24.1102C37.427 24.6395 37.128 25.357 37.127 26.1056V93.8385L37.4605 93.7372V26.1056C37.4613 25.4451 37.7251 24.8118 38.194 24.3448C38.6629 23.8777 39.2987 23.615 39.9619 23.6142H75.1683L75.0649 23.282ZM105.665 23.282H39.9619C39.2103 23.283 38.4899 23.5809 37.9585 24.1102C37.427 24.6395 37.128 25.357 37.127 26.1056V102.176C37.128 102.925 37.427 103.643 37.9585 104.172C38.4899 104.701 39.2103 104.999 39.9619 105H105.665C106.417 104.999 107.137 104.701 107.669 104.172C108.2 103.643 108.499 102.925 108.5 102.176V26.1056C108.499 25.357 108.2 24.6395 107.669 24.1102C107.137 23.5809 106.417 23.283 105.665 23.282ZM108.167 102.176C108.166 102.837 107.902 103.47 107.433 103.937C106.964 104.404 106.329 104.667 105.665 104.668H39.9619C39.2987 104.667 38.6629 104.404 38.194 103.937C37.7251 103.47 37.4613 102.837 37.4605 102.176V26.1056C37.4613 25.4451 37.7251 24.8118 38.194 24.3448C38.6629 23.8777 39.2987 23.615 39.9619 23.6142H105.665C106.329 23.615 106.964 23.8777 107.433 24.3448C107.902 24.8118 108.166 25.4451 108.167 26.1056V102.176Z"
                    fill="#3F3D56"
                />
                <path
                    d="M88.1554 30.59H57.4715C57.0736 30.5896 56.6921 30.432 56.4108 30.1517C56.1294 29.8715 55.9712 29.4915 55.9707 29.0952V21.7871C55.9712 21.3908 56.1294 21.0108 56.4108 20.7306C56.6922 20.4503 57.0736 20.2927 57.4715 20.2922H88.1554C88.5533 20.2927 88.9348 20.4503 89.2162 20.7306C89.4976 21.0108 89.6558 21.3908 89.6563 21.7871V29.0952C89.6558 29.4915 89.4976 29.8715 89.2162 30.1517C88.9348 30.432 88.5533 30.5896 88.1554 30.59Z"
                    fill="#236B48"
                />
                <path
                    d="M72.8137 20.7905C74.6557 20.7905 76.1489 19.3032 76.1489 17.4686C76.1489 15.634 74.6557 14.1467 72.8137 14.1467C70.9717 14.1467 69.4785 15.634 69.4785 17.4686C69.4785 19.3032 70.9717 20.7905 72.8137 20.7905Z"
                    fill="#236B48"
                />
                <path
                    d="M72.8127 19.492C73.9346 19.492 74.8442 18.5861 74.8442 17.4686C74.8442 16.3512 73.9346 15.4453 72.8127 15.4453C71.6908 15.4453 70.7812 16.3512 70.7812 17.4686C70.7812 18.5861 71.6908 19.492 72.8127 19.492Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_1026_593">
                    <rect
                        width="108"
                        height="105"
                        fill="white"
                        transform="translate(0.5)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export const LoadingIcon = (props: Props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="36"
            height="36"
            className="loading-icon"
            viewBox="0 0 22 22"
            fill="none"
            style={{ animation: "spin 1s linear infinite" }}
        >
            <path
                fill={props.color ? props.color : "white"}
                d="M9 18A9 9 0 1 1 9 0v2a7 7 0 1 0 7 7h2a9.01 9.01 0 0 1-9 9z"
                transform="translate(2.001 2)"
            />
        </svg>
    );
};

export const MicButton = (props: Props) => {
    return (
        <svg
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0466 1.17157C10.7967 0.421427 11.8141 0 12.875 0C13.9359 0 14.9533 0.421427 15.7034 1.17157C16.4536 1.92172 16.875 2.93913 16.875 4V12C16.875 13.0609 16.4536 14.0783 15.7034 14.8284C14.9533 15.5786 13.9359 16 12.875 16C11.8141 16 10.7967 15.5786 10.0466 14.8284C9.29643 14.0783 8.875 13.0609 8.875 12V4C8.875 2.93913 9.29643 1.92172 10.0466 1.17157ZM12.875 2C12.3446 2 11.8359 2.21071 11.4608 2.58579C11.0857 2.96086 10.875 3.46957 10.875 4V12C10.875 12.5304 11.0857 13.0391 11.4608 13.4142C11.8359 13.7893 12.3446 14 12.875 14C13.4054 14 13.9141 13.7893 14.2892 13.4142C14.6643 13.0391 14.875 12.5304 14.875 12V4C14.875 3.46957 14.6643 2.96086 14.2892 2.58579C13.9141 2.21071 13.4054 2 12.875 2Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.875 9C6.42728 9 6.875 9.44772 6.875 10V12C6.875 13.5913 7.50714 15.1174 8.63236 16.2426C9.75758 17.3679 11.2837 18 12.875 18C14.4663 18 15.9924 17.3679 17.1176 16.2426C18.2429 15.1174 18.875 13.5913 18.875 12V10C18.875 9.44772 19.3227 9 19.875 9C20.4273 9 20.875 9.44772 20.875 10V12C20.875 14.1217 20.0321 16.1566 18.5319 17.6569C17.0316 19.1571 14.9967 20 12.875 20C10.7533 20 8.71844 19.1571 7.21815 17.6569C5.71785 16.1566 4.875 14.1217 4.875 12V10C4.875 9.44772 5.32272 9 5.875 9Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.875 18C13.4273 18 13.875 18.4477 13.875 19V23C13.875 23.5523 13.4273 24 12.875 24C12.3227 24 11.875 23.5523 11.875 23V19C11.875 18.4477 12.3227 18 12.875 18Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.875 23C7.875 22.4477 8.32272 22 8.875 22H16.875C17.4273 22 17.875 22.4477 17.875 23C17.875 23.5523 17.4273 24 16.875 24H8.875C8.32272 24 7.875 23.5523 7.875 23Z"
                fill="white"
            />
        </svg>
    );
};

export const ScrollDownArrow = (props: Props) => {
    return (
        <svg
            width="43"
            height="48"
            viewBox="0 0 43 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.53333 28.4106L21.8667 42.6161L35.2 28.4106"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.53333 7.10254L21.8667 21.3079L35.2 7.10254"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const TickMark = (props: Props) => {
    return (
        <svg
            width="34"
            height="34"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 40C14.6956 40 9.6084 37.8928 5.858 34.142C2.10736 30.3912 0 25.304 0 20C0 14.696 2.1072 9.6084 5.858 5.858C9.6088 2.10736 14.696 0 20 0C25.304 0 30.3916 2.1072 34.142 5.858C37.8926 9.6088 40 14.696 40 20C40 23.5108 39.0759 26.9596 37.3205 30C35.5652 33.0403 33.0405 35.5652 30.0001 37.3204C26.9598 39.0759 23.5109 39.9999 20.0001 39.9999L20 40ZM20 4C15.7564 4 11.6868 5.6858 8.6864 8.6864C5.68592 11.687 4 15.7568 4 20C4 24.2432 5.6858 28.3132 8.6864 31.3136C11.687 34.3141 15.7568 36 20 36C24.2432 36 28.3132 34.3142 31.3136 31.3136C34.3141 28.313 36 24.2432 36 20C36 17.1914 35.2606 14.4324 33.8564 12C32.4522 9.56764 30.4323 7.548 28 6.1436C25.5676 4.7394 22.8084 4 20 4Z"
                fill="#00490A"
            />
            <path
                d="M17.8201 27.0998C17.2856 27.0976 16.7743 26.8815 16.4001 26.4998L10.5801 20.6798C10.2076 20.3051 9.99854 19.7982 9.99854 19.2698C9.99854 18.7413 10.2076 18.2344 10.5801 17.8598C10.9556 17.4812 11.4668 17.2682 12.0001 17.2682C12.5334 17.2682 13.0446 17.4812 13.4201 17.8598L17.8201 22.2598L26.5801 13.4998C26.9556 13.1212 27.4668 12.9082 28.0001 12.9082C28.5334 12.9082 29.0446 13.1212 29.4201 13.4998C29.7926 13.8745 30.0017 14.3813 30.0017 14.9098C30.0017 15.4382 29.7926 15.9451 29.4201 16.3198L19.2401 26.4998C18.8659 26.8815 18.3546 27.0976 17.8201 27.0998Z"
                fill="#00490A"
            />
        </svg>
    );
};

export const GenAiIcon1 = () => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="35" cy="35" r="34.4" stroke="white" strokeWidth="1.2" />
            <path
                d="M44.7442 36.877C44.0184 38.492 42.9751 39.9325 41.6596 41.1547V51.2816C41.6596 51.7181 41.2967 52.111 40.7978 52.111H25.194C24.7404 52.111 24.3322 51.7618 24.3322 51.2816V48.5316L21.4744 48.9245H21.3383C19.3424 48.9245 17.7095 47.3531 17.7095 45.4324V41.5475H17.3013C16.3034 41.5475 15.4869 41.1546 15.0786 40.4999C14.6703 39.8451 14.6703 38.9285 15.1239 38.0991L17.7093 33.3412V31.4206C17.7093 26.1825 20.8845 21.381 25.8287 19.1548C27.507 18.369 29.3213 17.9325 31.2265 17.8889C31.6801 17.8889 32.0884 18.2382 32.1337 18.6747C32.1337 19.1112 31.7708 19.5041 31.3172 19.5477C29.6843 19.6349 28.0967 19.9842 26.5998 20.6826C22.2452 22.6468 19.4329 26.8373 19.4329 31.4642V33.5595C19.4329 33.6905 19.3876 33.8214 19.3423 33.9524L16.666 38.8849C16.4846 39.2342 16.4392 39.496 16.5299 39.6707C16.6205 39.8453 16.9382 39.9326 17.3009 39.9326H18.5711C19.0247 39.9326 19.4329 40.2818 19.4329 40.7619L19.4334 45.4762C19.4334 46.4802 20.2499 47.3094 21.2931 47.3094L25.058 46.7857C25.2848 46.7421 25.5569 46.8293 25.7384 46.9603C25.9199 47.135 26.0559 47.3532 26.0559 47.5715V50.4524H39.9813V40.762C39.9813 40.5437 40.0719 40.3255 40.2534 40.1508C41.5236 39.016 42.5214 37.7064 43.2018 36.1786C43.3833 35.7858 43.8822 35.5675 44.3358 35.7421C44.6989 36.004 44.9256 36.4841 44.7442 36.877L44.7442 36.877ZM37.9856 36.4841V33.0793H36.8969C35.0825 33.0793 33.5856 31.6388 33.5856 29.8927V21.0753C33.5856 19.3293 35.0825 17.8888 36.8969 17.8888H51.9109C53.7253 17.8888 55.2223 19.3293 55.2223 21.0753V29.8927C55.2223 31.6388 53.7253 33.0793 51.9109 33.0793H43.7462L39.437 37.0515C39.2556 37.1825 39.0741 37.2697 38.8473 37.2697C38.7566 37.2697 38.6205 37.2697 38.5298 37.1825C38.167 37.1389 37.9856 36.8332 37.9856 36.4841ZM38.8474 31.4643C39.301 31.4643 39.7093 31.8136 39.7093 32.2937V34.6072L42.8392 31.7263C42.9753 31.5953 43.2021 31.5081 43.4289 31.5081H51.9565C52.8637 31.5081 53.5894 30.8097 53.5894 29.9367V21.1193C53.5894 20.2463 52.8637 19.5479 51.9565 19.5479H36.9425C36.0353 19.5479 35.3096 20.2463 35.3096 21.1193V29.9367C35.3096 30.8097 36.0353 31.5081 36.9425 31.5081L38.8474 31.5079L38.8474 31.4643ZM44.3813 26.8373C44.9711 26.8373 45.47 26.3572 45.47 25.7897C45.47 25.2222 44.9711 24.7421 44.3813 24.7421C43.7916 24.7421 43.2927 25.2222 43.2927 25.7897C43.3381 26.3571 43.7917 26.8373 44.3813 26.8373ZM40.299 26.8373C40.8887 26.8373 41.3876 26.3572 41.3876 25.7897C41.3876 25.2222 40.8887 24.7421 40.299 24.7421C39.7092 24.7421 39.2103 25.2222 39.2103 25.7897C39.2104 26.3571 39.7094 26.8373 40.299 26.8373ZM48.5091 26.8373C49.0988 26.8373 49.5977 26.3572 49.5977 25.7897C49.5977 25.2222 49.0988 24.7421 48.5091 24.7421C47.9193 24.7421 47.4204 25.2222 47.4204 25.7897C47.4204 26.3571 47.9193 26.8373 48.5091 26.8373Z"
                fill="white"
            />
        </svg>
    );
};

export const GenAiIcon2 = () => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="35" cy="35" r="34.4" stroke="white" strokeWidth="1.2" />
            <path
                d="M35.625 18.5938C35.3142 18.5938 35.0161 18.7172 34.7964 18.937C34.5765 19.1567 34.4531 19.4548 34.4531 19.7656V50.2344C34.4531 50.6531 34.6765 51.0399 35.0391 51.2493C35.4016 51.4586 35.8484 51.4586 36.2109 51.2493C36.5735 51.0399 36.7969 50.6531 36.7969 50.2344V19.7656C36.7969 19.4548 36.6735 19.1568 36.4536 18.937C36.2339 18.7172 35.9358 18.5938 35.625 18.5938Z"
                fill="white"
            />
            <path
                d="M41.4844 26.7969C41.1736 26.7969 40.8755 26.9203 40.6558 27.1401C40.4359 27.3599 40.3125 27.6579 40.3125 27.9688V43.2031C40.3125 43.6218 40.5359 44.0087 40.8984 44.218C41.261 44.4274 41.7077 44.4274 42.0703 44.218C42.4329 44.0087 42.6562 43.6218 42.6562 43.2031V27.9688C42.6562 27.658 42.5328 27.3599 42.313 27.1401C42.0933 26.9203 41.7952 26.7969 41.4844 26.7969Z"
                fill="white"
            />
            <path
                d="M47.3438 23.2812C47.033 23.2812 46.7349 23.4047 46.5151 23.6245C46.2953 23.8442 46.1719 24.1423 46.1719 24.4531V46.7188C46.1719 47.1374 46.3953 47.5243 46.7578 47.7337C47.1204 47.943 47.5671 47.943 47.9297 47.7337C48.2922 47.5243 48.5156 47.1375 48.5156 46.7188V24.4531C48.5156 24.1423 48.3922 23.8442 48.1724 23.6245C47.9526 23.4046 47.6546 23.2812 47.3438 23.2812Z"
                fill="white"
            />
            <path
                d="M53.2031 30.3125C52.8923 30.3125 52.5943 30.4359 52.3745 30.6558C52.1547 30.8755 52.0312 31.1736 52.0312 31.4844V39.6875C52.0312 40.1062 52.2546 40.493 52.6172 40.7024C52.9798 40.9118 53.4265 40.9118 53.7891 40.7024C54.1516 40.4931 54.375 40.1062 54.375 39.6875V31.4844C54.375 31.1736 54.2516 30.8755 54.0317 30.6558C53.812 30.4359 53.5139 30.3125 53.2031 30.3125Z"
                fill="white"
            />
            <path
                d="M29.7656 26.7969C29.4548 26.7969 29.1568 26.9203 28.937 27.1401C28.7172 27.3599 28.5938 27.6579 28.5938 27.9688V43.2031C28.5938 43.6218 28.8171 44.0087 29.1797 44.218C29.5423 44.4274 29.989 44.4274 30.3516 44.218C30.7141 44.0087 30.9375 43.6218 30.9375 43.2031V27.9688C30.9375 27.658 30.8141 27.3599 30.5942 27.1401C30.3745 26.9203 30.0764 26.7969 29.7656 26.7969Z"
                fill="white"
            />
            <path
                d="M23.9062 23.2812C23.5955 23.2812 23.2974 23.4047 23.0776 23.6245C22.8578 23.8442 22.7344 24.1423 22.7344 24.4531V46.7188C22.7344 47.1374 22.9578 47.5243 23.3203 47.7337C23.6829 47.943 24.1296 47.943 24.4922 47.7337C24.8547 47.5243 25.0781 47.1375 25.0781 46.7188V24.4531C25.0781 24.1423 24.9547 23.8442 24.7349 23.6245C24.5151 23.4046 24.2171 23.2812 23.9062 23.2812Z"
                fill="white"
            />
            <path
                d="M18.0469 30.3125C17.7361 30.3125 17.438 30.4359 17.2183 30.6558C16.9984 30.8755 16.875 31.1736 16.875 31.4844V39.6875C16.875 40.1062 17.0984 40.493 17.4609 40.7024C17.8235 40.9118 18.2702 40.9118 18.6328 40.7024C18.9954 40.4931 19.2188 40.1062 19.2188 39.6875V31.4844C19.2188 31.1736 19.0953 30.8755 18.8755 30.6558C18.6558 30.4359 18.3577 30.3125 18.0469 30.3125Z"
                fill="white"
            />
        </svg>
    );
};

export const GenAiIcon3 = () => {
    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 70 70"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="35" cy="35" r="34.4" stroke="white" strokeWidth="1.2" />
            <path
                d="M48.4454 33.4196L29.6562 22.7439C29.0828 22.4187 28.3753 22.4187 27.7994 22.7439C27.2287 23.0718 26.875 23.6741 26.875 24.3272V45.6754C26.875 46.6843 27.7039 47.5 28.7291 47.5H28.7317C29.0571 47.5 29.3773 47.4161 29.6588 47.256L48.448 36.5804C49.0213 36.2552 49.375 35.6529 49.375 34.9998C49.3724 34.3493 49.0212 33.7444 48.4454 33.4191L48.4454 33.4196Z"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    );
};

export const QuoteIcon = () => {
    return (
        <svg
            width="50"
            height="40"
            viewBox="0 0 67 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.782 55.9991C8.85741 55.9991 0 46.9239 0 35.7306C0 33.586 0.327106 31.5186 0.929663 29.579L0.92838 29.5767C0.92838 29.5767 5.20094 6.69981 29.6039 0C29.6039 0 22.7421 6.35931 19.2039 15.4722C19.396 15.4663 19.5891 15.4627 19.7821 15.4627C22.9679 15.4627 25.9769 16.2352 28.6428 17.6063C27.4502 19.8012 26.4262 22.1045 25.6129 24.4604C25.2442 25.5322 24.6903 27.0962 24.4796 28.5544C23.7815 30.8791 23.429 33.2981 23.429 35.7315C23.429 42.421 26.0609 48.4818 30.3209 52.886C27.2699 54.8578 23.657 56 19.7822 56L19.782 55.9991ZM47.2179 55.9991C36.2933 55.9991 27.4359 46.9239 27.4359 35.7306C27.4359 33.586 27.763 31.5186 28.3655 29.579L28.3643 29.5767C28.3643 29.5767 32.6368 6.69981 57.0398 0C57.0398 0 50.178 6.35931 46.6398 15.4722C46.8319 15.4663 47.0249 15.4627 47.218 15.4627C58.1442 15.4627 67 24.5379 67 35.7312C67 46.9244 58.1434 55.9997 47.218 55.9997L47.2179 55.9991Z"
                fill="#BEBEBE"
            />
        </svg>
    );
};

export const LinkedinIcon = (props: Props) => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke={props.color ? props.color : "#161616"}
            />
            <path
                d="M19.3576 17.0295C19.3328 15.9131 18.5285 15.0628 17.2224 15.0628C15.9163 15.0628 15.0625 15.9131 15.0625 17.0295C15.0625 18.1227 15.8911 18.9975 17.1729 18.9975H17.1973C18.5285 18.9975 19.3576 18.1227 19.3576 17.0295Z"
                fill={props.color ? props.color : "#161616"}
            />
            <path
                d="M19.1061 20.5516H15.2882V31.9375H19.1061V20.5516Z"
                fill={props.color ? props.color : "#161616"}
            />
            <path
                d="M28.4791 20.2842C30.9915 20.2842 32.875 21.9119 32.875 25.4092L32.8748 31.9375H29.0571V25.846C29.0571 24.316 28.5046 23.2719 27.1225 23.2719C26.0677 23.2719 25.4395 23.9758 25.1635 24.6556C25.0626 24.8992 25.0378 25.2387 25.0378 25.579V31.9378H21.2194C21.2194 31.9378 21.2698 21.6203 21.2194 20.5519H25.0378V22.1646C25.5445 21.3893 26.4521 20.2842 28.4791 20.2842Z"
                fill={props.color ? props.color : "#161616"}
            />
        </svg>
    );
};

export const FBIcon = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke="#161616"
            />
            <path
                d="M20.0641 17.2965V20.0846H17.875V23.4935H20.0641V33.6251H24.5576V23.4946H27.5739C27.5739 23.4946 27.8565 21.8601 27.9935 20.0724H24.5761V17.7409C24.5761 17.3929 25.0652 16.9241 25.55 16.9241H28V13.3751H24.6696C19.9522 13.3751 20.0641 16.7872 20.0641 17.2965Z"
                fill="#161616"
            />
        </svg>
    );
};

export const TwitterIcon = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke="#161616"
            />
            <path
                d="M13.4487 14.4293L20.9182 25.1L13.4016 33.7757H15.0932L21.674 26.18L26.9911 33.7757H32.748L24.8583 22.5048L31.8547 14.4293H30.163L24.1024 21.4248L19.2056 14.4293H13.4487Z"
                fill="black"
            />
        </svg>
    );
};

export const InstagramIcon = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke="#161616"
            />
            <path
                d="M32.8148 19.6591C32.8043 18.8718 32.6567 18.0924 32.3785 17.3556C32.1373 16.7342 31.7689 16.1698 31.2969 15.6985C30.8248 15.2273 30.2595 14.8595 29.637 14.6187C28.9085 14.3457 28.1389 14.1981 27.361 14.1821C26.3593 14.1374 26.0418 14.125 23.4991 14.125C20.9565 14.125 20.6306 14.125 19.6363 14.1821C18.8587 14.1982 18.0894 14.3458 17.3612 14.6187C16.7387 14.8593 16.1733 15.227 15.7012 15.6983C15.2291 16.1696 14.8608 16.7341 14.6198 17.3556C14.3457 18.0824 14.1982 18.8505 14.1835 19.6269C14.1387 20.6279 14.1252 20.9449 14.1252 23.4833C14.1252 26.0217 14.1252 26.346 14.1835 27.3398C14.1991 28.1173 14.3459 28.8844 14.6198 29.6131C14.8612 30.2344 15.2298 30.7987 15.702 31.2698C16.1742 31.7409 16.7397 32.1084 17.3623 32.349C18.0885 32.633 18.8578 32.7912 19.6373 32.8167C20.64 32.8614 20.9576 32.875 23.5002 32.875C26.0428 32.875 26.3687 32.875 27.3631 32.8167C28.141 32.8015 28.9107 32.6542 29.6391 32.3812C30.2614 32.1401 30.8266 31.7723 31.2986 31.301C31.7706 30.8298 32.1391 30.2656 32.3806 29.6443C32.6544 28.9166 32.8013 28.1495 32.8169 27.371C32.8616 26.371 32.8752 26.0539 32.8752 23.5145C32.8731 20.9761 32.8731 20.6539 32.8148 19.6591ZM23.4929 28.2836C20.8337 28.2836 18.6794 26.1329 18.6794 23.4781C18.6794 20.8233 20.8337 18.6726 23.4929 18.6726C24.7695 18.6726 25.9938 19.1789 26.8965 20.0801C27.7992 20.9813 28.3064 22.2036 28.3064 23.4781C28.3064 24.7526 27.7992 25.9749 26.8965 26.8761C25.9938 27.7773 24.7695 28.2836 23.4929 28.2836ZM28.498 19.6154C28.3505 19.6156 28.2045 19.5867 28.0683 19.5304C27.932 19.4742 27.8082 19.3916 27.704 19.2876C27.5997 19.1835 27.5171 19.0599 27.4607 18.9239C27.4043 18.7879 27.3754 18.6421 27.3755 18.4949C27.3755 18.3478 27.4046 18.2022 27.4609 18.0663C27.5173 17.9304 27.6 17.8069 27.7041 17.7029C27.8083 17.5989 27.932 17.5164 28.0681 17.4601C28.2042 17.4038 28.3501 17.3749 28.4974 17.3749C28.6448 17.3749 28.7907 17.4038 28.9268 17.4601C29.0629 17.5164 29.1866 17.5989 29.2907 17.7029C29.3949 17.8069 29.4776 17.9304 29.5339 18.0663C29.5903 18.2022 29.6193 18.3478 29.6193 18.4949C29.6193 19.1144 29.1175 19.6154 28.498 19.6154Z"
                fill="#161616"
            />
            <path
                d="M23.4926 26.5994C25.2194 26.5994 26.6193 25.2019 26.6193 23.4779C26.6193 21.7539 25.2194 20.3564 23.4926 20.3564C21.7657 20.3564 20.3658 21.7539 20.3658 23.4779C20.3658 25.2019 21.7657 26.5994 23.4926 26.5994Z"
                fill="#161616"
            />
        </svg>
    );
};

export const MailIcon = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke="#161616"
            />
            <path
                d="M25.3618 26.0527L34.9796 20.6394V30.3136C34.9796 31.3677 34.1351 32.2246 33.097 32.2246H14.8215C13.7834 32.2246 12.9388 31.3677 12.9388 30.3136V20.6394L22.5564 26.0527C23.4346 26.547 24.4837 26.547 25.3619 26.0527H25.3618ZM33.097 15.6939H14.8215C13.7833 15.6939 12.9388 16.5508 12.9388 17.6049V19.1984L23.1582 24.95C23.6594 25.232 24.2588 25.232 24.76 24.95L34.9796 19.1984V17.6049C34.9796 16.5508 34.1351 15.6939 33.0969 15.6939H33.097Z"
                fill="black"
            />
        </svg>
    );
};

export const WebIcon = () => {
    return (
        <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23.5C1 11.0736 11.0736 1 23.5 1C35.9264 1 46 11.0736 46 23.5C46 35.9264 35.9264 46 23.5 46C11.0736 46 1 35.9264 1 23.5Z"
                stroke="#161616"
            />
            <path
                d="M20.7151 11.4324C18.3941 12.0357 16.3219 13.2508 14.6914 14.9088C15.7185 15.5918 16.8437 16.1066 18.042 16.3839C18.2681 16.4359 18.4977 16.4758 18.7256 16.5217C19.1935 14.5022 19.8602 12.7246 20.7151 11.4324ZM27.558 31.185C26.7092 34.7421 25.3066 37 24.0005 37C22.6944 37 21.2918 34.7413 20.4431 31.1844C22.8014 30.8654 25.1996 30.8654 27.5589 31.1844L27.558 31.185ZM19.669 24.8658H28.3318C28.2917 26.5246 28.1396 28.0771 27.9013 29.4828C25.316 29.1222 22.6838 29.1231 20.0993 29.4828C19.8611 28.077 19.7098 26.5246 19.669 24.8658ZM20.0994 18.5153C21.3925 18.6964 22.6969 18.7987 24.0006 18.7987C25.304 18.7987 26.6084 18.6981 27.9017 18.5161C28.1399 19.9211 28.2913 21.4734 28.3312 23.1324H19.6684C19.7085 21.4735 19.8612 19.9201 20.0994 18.5153ZM17.6481 18.0724C17.8933 18.1296 18.1421 18.1711 18.3882 18.2214C18.1229 19.7998 17.969 21.4665 17.929 23.1324H11.0001C11.1714 20.5625 12.0914 18.2006 13.5497 16.2522C14.7932 17.1094 16.1784 17.7326 17.6481 18.0724ZM17.929 24.8659C17.969 26.5317 18.1229 28.1985 18.3882 29.7769C18.1413 29.8272 17.8934 29.8696 17.6481 29.9269C16.1785 30.2675 14.7933 30.8899 13.5497 31.747C12.0922 29.7986 11.1714 27.436 11 24.8661L17.929 24.8659ZM30.0711 23.1324C30.0311 21.4683 29.8772 19.8026 29.6119 18.2251C29.7346 18.2 29.858 18.1818 29.9798 18.1558C31.5728 17.8091 33.0781 17.1495 34.4321 16.2282C35.9 18.181 36.8278 20.5524 36.9991 23.1327L30.0711 23.1324ZM29.2754 31.4739C29.3868 31.4964 29.4989 31.5129 29.6102 31.5372C30.9242 31.8232 32.1722 32.3545 33.3033 33.0973C31.6738 34.7518 29.6033 35.9644 27.2857 36.5667C28.1414 35.2736 28.8077 33.4951 29.2754 31.4739ZM18.0419 31.6152C18.268 31.5632 18.4975 31.5232 18.7254 31.4774C19.1933 33.4969 19.8603 35.2753 20.7159 36.5678C18.3949 35.9645 16.3227 34.7493 14.6923 33.0914C15.7193 32.4092 16.8436 31.8936 18.0429 31.6153L18.0419 31.6152ZM29.6119 29.7751C29.8771 28.1976 30.031 26.5319 30.0711 24.8668L37 24.8669C36.8278 27.4472 35.9009 29.8186 34.433 31.7714C33.079 30.8501 31.5737 30.1914 29.9806 29.8447C29.8589 29.8178 29.7345 29.8002 29.6119 29.7751ZM29.6093 16.463C29.4979 16.4873 29.3858 16.5037 29.2745 16.5263C28.8066 14.5051 28.1396 12.7266 27.284 11.4334C29.6015 12.0358 31.6721 13.2483 33.3016 14.9029C32.1711 15.6456 30.9234 16.177 29.6093 16.463ZM20.4421 16.815C21.2909 13.2579 22.6935 11 23.9996 11C25.3057 11 26.7083 13.2587 27.557 16.815C25.1978 17.1339 22.7995 17.1347 20.4421 16.815Z"
                fill="black"
            />
        </svg>
    );
};

export const PoweredByLogo = (props: Props) => {
    return (
        <svg
            width={props.width ? props.width : "87"}
            height={props.height ? props.height : "11"}
            viewBox="0 0 87 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.74686 6.00047C3.74686 6.21247 3.69686 6.41247 3.59686 6.60047C3.49686 6.78847 3.33686 6.94247 3.11686 7.06247C2.89686 7.17847 2.61486 7.23647 2.27086 7.23647H1.51486V8.92847H0.830859V4.75847H2.27086C2.59086 4.75847 2.86086 4.81447 3.08086 4.92647C3.30486 5.03447 3.47086 5.18247 3.57886 5.37047C3.69086 5.55847 3.74686 5.76847 3.74686 6.00047ZM2.27086 6.67847C2.53086 6.67847 2.72486 6.62047 2.85286 6.50447C2.98086 6.38447 3.04486 6.21647 3.04486 6.00047C3.04486 5.54447 2.78686 5.31647 2.27086 5.31647H1.51486V6.67847H2.27086ZM5.83322 8.98247C5.52122 8.98247 5.23922 8.91247 4.98722 8.77247C4.73522 8.62847 4.53722 8.42847 4.39322 8.17247C4.24922 7.91247 4.17722 7.61247 4.17722 7.27247C4.17722 6.93647 4.25122 6.63847 4.39922 6.37847C4.54722 6.11847 4.74922 5.91847 5.00522 5.77847C5.26122 5.63847 5.54722 5.56847 5.86322 5.56847C6.17922 5.56847 6.46522 5.63847 6.72122 5.77847C6.97722 5.91847 7.17922 6.11847 7.32722 6.37847C7.47522 6.63847 7.54922 6.93647 7.54922 7.27247C7.54922 7.60847 7.47322 7.90647 7.32122 8.16647C7.16922 8.42647 6.96122 8.62847 6.69722 8.77247C6.43722 8.91247 6.14922 8.98247 5.83322 8.98247ZM5.83322 8.38847C6.00922 8.38847 6.17322 8.34647 6.32522 8.26247C6.48122 8.17847 6.60722 8.05247 6.70322 7.88447C6.79922 7.71647 6.84722 7.51247 6.84722 7.27247C6.84722 7.03247 6.80122 6.83047 6.70922 6.66647C6.61722 6.49847 6.49522 6.37247 6.34322 6.28847C6.19122 6.20447 6.02722 6.16247 5.85122 6.16247C5.67522 6.16247 5.51122 6.20447 5.35922 6.28847C5.21122 6.37247 5.09322 6.49847 5.00522 6.66647C4.91722 6.83047 4.87322 7.03247 4.87322 7.27247C4.87322 7.62847 4.96322 7.90447 5.14322 8.10047C5.32722 8.29247 5.55722 8.38847 5.83322 8.38847ZM12.6654 5.62247L11.6394 8.92847H10.9194L10.2534 6.48647L9.58739 8.92847H8.86739L7.83539 5.62247H8.53139L9.22139 8.28047L9.92339 5.62247H10.6374L11.3094 8.26847L11.9934 5.62247H12.6654ZM16.2066 7.19447C16.2066 7.31847 16.1986 7.43047 16.1826 7.53047H13.6566C13.6766 7.79447 13.7746 8.00647 13.9506 8.16647C14.1266 8.32647 14.3426 8.40647 14.5986 8.40647C14.9666 8.40647 15.2266 8.25247 15.3786 7.94447H16.1166C16.0166 8.24847 15.8346 8.49847 15.5706 8.69447C15.3106 8.88647 14.9866 8.98247 14.5986 8.98247C14.2826 8.98247 13.9986 8.91247 13.7466 8.77247C13.4986 8.62847 13.3026 8.42847 13.1586 8.17247C13.0186 7.91247 12.9486 7.61247 12.9486 7.27247C12.9486 6.93247 13.0166 6.63447 13.1526 6.37847C13.2926 6.11847 13.4866 5.91847 13.7346 5.77847C13.9866 5.63847 14.2746 5.56847 14.5986 5.56847C14.9106 5.56847 15.1886 5.63647 15.4326 5.77247C15.6766 5.90847 15.8666 6.10047 16.0026 6.34847C16.1386 6.59247 16.2066 6.87447 16.2066 7.19447ZM15.4926 6.97847C15.4886 6.72647 15.3986 6.52447 15.2226 6.37247C15.0466 6.22047 14.8286 6.14447 14.5686 6.14447C14.3326 6.14447 14.1306 6.22047 13.9626 6.37247C13.7946 6.52047 13.6946 6.72247 13.6626 6.97847H15.4926ZM17.5637 6.10247C17.6637 5.93447 17.7957 5.80447 17.9597 5.71247C18.1277 5.61647 18.3257 5.56847 18.5537 5.56847V6.27647H18.3797C18.1117 6.27647 17.9077 6.34447 17.7677 6.48047C17.6317 6.61647 17.5637 6.85247 17.5637 7.18847V8.92847H16.8797V5.62247H17.5637V6.10247ZM22.2124 7.19447C22.2124 7.31847 22.2044 7.43047 22.1884 7.53047H19.6624C19.6824 7.79447 19.7804 8.00647 19.9564 8.16647C20.1324 8.32647 20.3484 8.40647 20.6044 8.40647C20.9724 8.40647 21.2324 8.25247 21.3844 7.94447H22.1224C22.0224 8.24847 21.8404 8.49847 21.5764 8.69447C21.3164 8.88647 20.9924 8.98247 20.6044 8.98247C20.2884 8.98247 20.0044 8.91247 19.7524 8.77247C19.5044 8.62847 19.3084 8.42847 19.1644 8.17247C19.0244 7.91247 18.9544 7.61247 18.9544 7.27247C18.9544 6.93247 19.0224 6.63447 19.1584 6.37847C19.2984 6.11847 19.4924 5.91847 19.7404 5.77847C19.9924 5.63847 20.2804 5.56847 20.6044 5.56847C20.9164 5.56847 21.1944 5.63647 21.4384 5.77247C21.6824 5.90847 21.8724 6.10047 22.0084 6.34847C22.1444 6.59247 22.2124 6.87447 22.2124 7.19447ZM21.4984 6.97847C21.4944 6.72647 21.4044 6.52447 21.2284 6.37247C21.0524 6.22047 20.8344 6.14447 20.5744 6.14447C20.3384 6.14447 20.1364 6.22047 19.9684 6.37247C19.8004 6.52047 19.7004 6.72247 19.6684 6.97847H21.4984ZM22.6575 7.26047C22.6575 6.92847 22.7255 6.63447 22.8615 6.37847C23.0015 6.12247 23.1895 5.92447 23.4255 5.78447C23.6655 5.64047 23.9315 5.56847 24.2235 5.56847C24.4395 5.56847 24.6515 5.61647 24.8595 5.71247C25.0715 5.80447 25.2395 5.92847 25.3635 6.08447V4.48847H26.0535V8.92847H25.3635V8.43047C25.2515 8.59047 25.0955 8.72247 24.8955 8.82647C24.6995 8.93047 24.4735 8.98247 24.2175 8.98247C23.9295 8.98247 23.6655 8.91047 23.4255 8.76647C23.1895 8.61847 23.0015 8.41447 22.8615 8.15447C22.7255 7.89047 22.6575 7.59247 22.6575 7.26047ZM25.3635 7.27247C25.3635 7.04447 25.3155 6.84647 25.2195 6.67847C25.1275 6.51047 25.0055 6.38247 24.8535 6.29447C24.7015 6.20647 24.5375 6.16247 24.3615 6.16247C24.1855 6.16247 24.0215 6.20647 23.8695 6.29447C23.7175 6.37847 23.5935 6.50447 23.4975 6.67247C23.4055 6.83647 23.3595 7.03247 23.3595 7.26047C23.3595 7.48847 23.4055 7.68847 23.4975 7.86047C23.5935 8.03247 23.7175 8.16447 23.8695 8.25647C24.0255 8.34447 24.1895 8.38847 24.3615 8.38847C24.5375 8.38847 24.7015 8.34447 24.8535 8.25647C25.0055 8.16847 25.1275 8.04047 25.2195 7.87247C25.3155 7.70047 25.3635 7.50047 25.3635 7.27247ZM29.1945 6.11447C29.3105 5.95447 29.4685 5.82447 29.6685 5.72447C29.8725 5.62047 30.0985 5.56847 30.3465 5.56847C30.6385 5.56847 30.9025 5.63847 31.1385 5.77847C31.3745 5.91847 31.5605 6.11847 31.6965 6.37847C31.8325 6.63447 31.9005 6.92847 31.9005 7.26047C31.9005 7.59247 31.8325 7.89047 31.6965 8.15447C31.5605 8.41447 31.3725 8.61847 31.1325 8.76647C30.8965 8.91047 30.6345 8.98247 30.3465 8.98247C30.0905 8.98247 29.8625 8.93247 29.6625 8.83247C29.4665 8.73247 29.3105 8.60447 29.1945 8.44847V8.92847H28.5105V4.48847H29.1945V6.11447ZM31.2045 7.26047C31.2045 7.03247 31.1565 6.83647 31.0605 6.67247C30.9685 6.50447 30.8445 6.37847 30.6885 6.29447C30.5365 6.20647 30.3725 6.16247 30.1965 6.16247C30.0245 6.16247 29.8605 6.20647 29.7045 6.29447C29.5525 6.38247 29.4285 6.51047 29.3325 6.67847C29.2405 6.84647 29.1945 7.04447 29.1945 7.27247C29.1945 7.50047 29.2405 7.70047 29.3325 7.87247C29.4285 8.04047 29.5525 8.16847 29.7045 8.25647C29.8605 8.34447 30.0245 8.38847 30.1965 8.38847C30.3725 8.38847 30.5365 8.34447 30.6885 8.25647C30.8445 8.16447 30.9685 8.03247 31.0605 7.86047C31.1565 7.68847 31.2045 7.48847 31.2045 7.26047ZM35.553 5.62247L33.525 10.4825H32.817L33.489 8.87447L32.187 5.62247H32.949L33.879 8.14247L34.845 5.62247H35.553Z"
                fill="black"
            />
            <path
                d="M76.6909 7.69766C76.6909 8.88562 75.7345 9.84863 74.5547 9.84863C73.3747 9.84863 72.4183 8.88562 72.4183 7.69766C72.4183 6.50976 73.3747 5.54675 74.5547 5.54675C75.7345 5.54675 76.6909 6.50976 76.6909 7.69766Z"
                fill="#ED2724"
            />
            <path
                d="M81.5098 7.69766C81.5098 8.88562 80.5533 9.84863 79.3733 9.84863C78.1936 9.84863 77.2369 8.88562 77.2369 7.69766C77.2369 6.50976 78.1936 5.54675 79.3733 5.54675C80.5533 5.54675 81.5098 6.50976 81.5098 7.69766Z"
                fill="#F9AF0D"
            />
            <path
                d="M86.3317 7.69766C86.3317 8.88562 85.3752 9.84863 84.1952 9.84863C83.0152 9.84863 82.0588 8.88562 82.0588 7.69766C82.0588 6.50976 83.0152 5.54675 84.1952 5.54675C85.3752 5.54675 86.3317 6.50976 86.3317 7.69766Z"
                fill="#3E8BD1"
            />
            <path
                d="M43.5541 5.53697H42.1437V9.75806H40.5868V5.53697H40V4.19809H40.5868V2.41666C40.5868 1.61116 40.8011 1.00969 41.2186 0.61251C41.636 0.204139 42.1437 -7.24792e-05 42.7418 -7.24792e-05C43.0464 -7.24792e-05 43.3172 0.0566702 43.5541 0.181476V1.59974C43.2947 1.46351 43.0689 1.39558 42.8547 1.39558C42.3468 1.39558 42.1437 1.74723 42.1437 2.64361V4.19809H43.5541V5.53697Z"
                fill="black"
            />
            <path
                d="M44.2757 9.75806V4.19822H45.8327V5.0378C46.2163 4.35703 46.7466 4.01667 47.4348 4.01667C47.6492 4.01667 47.875 4.062 48.1118 4.15282L47.8975 5.61651C47.6605 5.4917 47.4123 5.42364 47.1528 5.42364C46.2727 5.42364 45.8327 5.97971 45.8327 7.09151V9.75806H44.2757Z"
                fill="black"
            />
            <path
                d="M52.5917 5.88835C52.2871 5.5819 51.9261 5.42314 51.5085 5.42314C51.0685 5.42314 50.7074 5.57068 50.4028 5.87693C50.1095 6.18316 49.9628 6.54636 49.9628 6.97765C49.9628 7.40868 50.1095 7.77173 50.4028 8.07821C50.7074 8.38457 51.0685 8.53214 51.5085 8.53214C51.9261 8.53214 52.2871 8.38457 52.5917 8.07821C52.8963 7.77173 53.0543 7.40868 53.0543 6.98884C53.0543 6.5577 52.8963 6.19471 52.5917 5.88835ZM52.885 4.19762H54.4421V9.75755H52.885V9.03136C52.4111 9.63262 51.8132 9.92773 51.0798 9.92773C50.3013 9.92773 49.6581 9.64397 49.1391 9.07666C48.6201 8.50927 48.3607 7.80596 48.3607 6.9662C48.3607 6.13786 48.6201 5.43443 49.1279 4.86707C49.6356 4.29976 50.2788 4.01617 51.0459 4.01617C51.7568 4.01617 52.3773 4.31108 52.885 4.91244V4.19762Z"
                fill="black"
            />
            <path
                d="M59.8449 5.88835C59.4499 5.5819 59.0212 5.42314 58.5812 5.42314C57.6787 5.42314 57.0016 6.0699 57.0016 6.97765C57.0016 7.88532 57.6787 8.53214 58.5812 8.53214C59.0212 8.53214 59.4499 8.37325 59.8449 8.06692V9.59867C59.3597 9.81402 58.8858 9.92773 58.4233 9.92773C57.5545 9.92773 56.8324 9.64396 56.257 9.08787C55.6816 8.53214 55.3995 7.8286 55.3995 7.00026C55.3995 6.14931 55.6928 5.44577 56.2683 4.87839C56.855 4.29976 57.577 4.01617 58.4459 4.01617C58.9536 4.01617 59.4161 4.12958 59.8449 4.3565V5.88835Z"
                fill="black"
            />
            <path
                d="M61.267 5.5365H60.6577V4.19762H61.267V2.30277H62.8241V4.19762H63.9072V5.5365H62.8241V7.19315C62.8241 8.1463 62.9595 8.5548 63.501 8.5548C63.5799 8.5548 63.6816 8.54338 63.7831 8.53216V9.89355C63.6139 9.91634 63.3882 9.92773 63.1287 9.92773C61.9552 9.92773 61.267 9.06534 61.267 7.74925V5.5365Z"
                fill="black"
            />
            <path
                d="M68.6119 5.88835C68.3072 5.5819 67.9462 5.42314 67.5289 5.42314C67.0888 5.42314 66.7278 5.57068 66.4231 5.87693C66.1296 6.18316 65.9831 6.54636 65.9831 6.97765C65.9831 7.40868 66.1296 7.77173 66.4231 8.07821C66.7278 8.38457 67.0888 8.53214 67.5289 8.53214C67.9462 8.53214 68.3072 8.38457 68.6119 8.07821C68.9165 7.77173 69.0744 7.40868 69.0744 6.98884C69.0744 6.5577 68.9165 6.19471 68.6119 5.88835ZM68.9054 4.19762H70.4623V9.75755H68.9054V9.03136C68.4315 9.63262 67.8333 9.92773 67.1002 9.92773C66.3216 9.92773 65.6784 9.64397 65.1594 9.07666C64.6404 8.50927 64.3809 7.80596 64.3809 6.9662C64.3809 6.13786 64.6404 5.43443 65.1481 4.86707C65.6559 4.29976 66.2988 4.01617 67.0663 4.01617C67.7769 4.01617 68.3974 4.31108 68.9054 4.91244V4.19762Z"
                fill="black"
            />
            <path
                d="M73.9019 8.55543C73.3605 8.55543 73.1807 8.11242 73.1807 7.19295V0.135575H71.6232V7.68159C71.6232 9.0429 72.277 9.92773 73.598 9.92773C73.767 9.92773 73.9471 9.91677 74.1171 9.89342V8.53214C74.0156 8.54325 73.936 8.55543 73.9019 8.55543Z"
                fill="black"
            />
        </svg>
    );
};

export const StarIcon = () => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.2933 26.882C10.5705 25.0562 11.9133 20.5183 10.4714 19.1009C9.56629 18.1904 8.70859 17.232 7.85194 16.275C7.41289 15.7268 6.9012 15.187 6.64219 14.5244C6.20745 13.2017 7.93894 13.161 8.81749 12.979C10.0194 12.6084 14.0682 12.3381 14.5459 11.508C15.4073 10.084 16.2471 8.64706 17.0937 7.21418C17.463 6.47281 18.4716 6.38791 18.9008 7.12853C19.6794 8.62122 20.5605 10.0553 21.4534 11.4834C21.7257 11.9261 22.0925 12.1423 22.6447 12.1653C24.8124 12.3051 27.0079 12.313 29.1575 12.6248C31.0674 13.2756 28.9862 14.858 28.2787 15.6313C27.2395 16.7045 26.1862 17.7643 25.1578 18.8477C24.4188 19.6262 24.4452 19.637 24.6331 20.6892C24.9643 22.7327 25.4101 24.7682 25.658 26.8205C25.6233 27.7661 24.9245 28.1914 24.0872 27.75C22.0788 26.7071 20.1348 25.5384 18.0645 24.6194C17.8262 24.5065 17.6213 24.5543 17.3968 24.6908C15.8278 25.6446 14.2547 26.5917 12.6751 27.5277C11.7745 28.1487 10.2678 28.5542 10.2933 26.882Z"
                fill="black"
            />
            <path
                d="M23.8321 8.7814C24.2025 7.66697 26.3848 3.26807 27.4389 3.04442C28.2096 2.85366 28.8311 3.76649 28.4309 4.42874C27.501 5.8147 26.6612 7.26629 25.7769 8.68394C25.6277 8.92615 25.4854 9.17755 25.3024 9.3928C24.773 10.0086 23.8399 9.57576 23.8321 8.7814Z"
                fill="black"
            />
            <path
                d="M8.22304 4.74041C8.27828 3.94035 9.15094 3.45459 9.79403 3.94147C10.9791 5.21902 11.869 6.77715 12.9366 8.16112C13.5745 8.90966 12.7471 10.0629 11.8644 9.531C10.6216 8.35215 9.7041 6.83231 8.6085 5.51081C8.43765 5.28626 8.34945 4.99878 8.22304 4.74041Z"
                fill="black"
            />
            <path
                d="M16.4974 31.206C16.5803 30.0793 16.656 28.9521 16.7532 27.8266C16.7999 27.2163 17.3842 26.6386 18.0045 26.8334C18.4107 26.9475 18.7029 27.3024 18.6962 27.7395C18.6668 29.0685 18.6328 30.3989 18.5783 31.727C18.6603 33.0762 16.8671 33.5172 16.5332 32.1431C16.4891 31.8372 16.5248 31.5198 16.5248 31.2075C16.5157 31.207 16.5065 31.2065 16.4974 31.206Z"
                fill="black"
            />
            <path
                d="M4.10081 24.8116C3.33343 24.7544 2.88388 23.9803 3.26976 23.3366C3.91549 22.5571 4.9254 22.1195 5.76484 21.573C6.46309 21.2884 7.73227 20.3983 8.39861 21.004C8.90606 21.4369 8.76652 22.167 8.13334 22.5069C7.40632 22.8971 6.68572 23.3007 5.97652 23.7223C5.3589 24.106 4.8141 24.6029 4.10081 24.8116Z"
                fill="black"
            />
            <path
                d="M31.623 22.0631C30.5031 21.8036 29.2438 21.3723 28.1207 21.0303C27.0568 20.8235 26.9943 19.2671 28.152 19.188C29.5238 19.4022 30.9072 19.7797 32.233 20.1943C33.2473 20.7278 32.8716 22.1381 31.623 22.0631Z"
                fill="black"
            />
        </svg>
    );
};

export const LikeIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 8 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.00187 5.89451L1.45565 3.64006C0.0718358 2.28737 2.10604 -0.309775 4.00187 1.79139C5.89768 -0.309775 7.9227 2.29639 6.5481 3.64006L4.00187 5.89451Z"
                fill="#FF0000"
                stroke="#FF0000"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
